import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset } from "redux-form";
import { FormField } from "../../../sharedComponents/formField";

import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";

const FilterHistory = ({ show, update, myHistoryGraphList, handleSubmit, resetForm }) => {
	const timeSpan = [
		{ name: "All History", id: "" },
		{ name: "Last two weeks", id: "two_week" },
		{ name: "Last four weeks", id: "four_week" },
		{ name: "Last six weeks", id: "six_week" },
		{ name: "Last eight weeks", id: "eight_week" }
	];
	const groupBy = [{ name: "Day", id: "day" }, { name: "Week", id: "week" }];

	return (
		<FilterPanel show={show} toggle={update} title="Filter history" className="hide-sub-header" closeBtn>
			<form onSubmit={handleSubmit} className="flex-fill d-flex flex-column">
				<PanelBody>
					<div className="row">
						{myHistoryGraphList && myHistoryGraphList.exercise && (
							<Field
								label={"Exercises"}
								name="exercise"
								type="select"
								formGroupClass="col-12"
								options={myHistoryGraphList.exercise}
								component={FormField}
							/>
						)}
						<Field
							label={"Time Span"}
							name="time_span"
							type="select"
							formGroupClass="col-12"
							options={timeSpan}
							component={FormField}
						/>
						<Field
							label={"Group By"}
							name="group_by"
							type="select"
							formGroupClass="col-12"
							options={groupBy}
							component={FormField}
						/>
					</div>
				</PanelBody>
				<PanelFooter className="text-right">
					<button type="button" className="btn btn-default" onClick={() => {
						resetForm("FilterHistoryForm");
						setTimeout(() => {
							handleSubmit();
						}, 100);
						update(false);
					}}>
						Reset
					</button>
					<button type="submit" className="btn btn-primary-dark">
						Apply
					</button>
				</PanelFooter>
			</form>
		</FilterPanel>
	);
};

const mapDispatchToProps = {
	resetForm: reset
};
const mapStateToProps = (state) => {
	const { MyProgress } = state;
	return {
		myHistoryGraphList: get(MyProgress, "myHistoryGraphResult", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "FilterHistoryForm"
	})(FilterHistory)
);
